import { createTheme } from '@mui/material/styles';

import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/700.css';

const containerBg = '#F8F9FA';//#F7F7F8 
const mainColor = '#6769DF';
const secondaryColor = '#14c4b4';

const theme = createTheme({
    typography: {
        fontFamily: [
            'Inter', // Primary font
            'Roboto', // Fallback for Material UI components
            'sans-serif',
        ].join(','),
        button: {
            textTransform: 'none', // This disables the default uppercase
        },
    },
    palette: {
        primary: {
            main: mainColor,//#5E17EB
            dark: "#4b4fc1",
            dark2: "#5E17EB",
            light1: "#9394f0",
            contrastText: '#FFF',
            lightText: '#212121b3',
            disabledInput: "rgba(0,0,0,0.04)",
            containerBg: containerBg
        },
        secondary: {
            main: secondaryColor,
            dark: "#0e8e84",
            contrastText: '#fff'
        },
        tertiary: {
            main: "#800080",
            contrastText: '#fff'
        },
    },
    components: {
        MuiDialog: {
            styleOverrides: {
                paper: {
                    backgroundColor: containerBg,
                    backgroundImage: 'none',
                    borderRadius: 8,
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFF',
                    margin: "16px 24px",
                    padding: "10px 20px !important",
                    border: "1px solid " + containerBg,
                    borderRadius: 8,
                    display: "flex"
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    padding: "15px 0px 0px 24px"
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: mainColor,
                    color: 'white',
                    borderRadius: '4px',
                },
                arrow: {
                    color: mainColor,
                },
            },
        },
        MuiRating: {
      styleOverrides: {
        // Target the active/filled star icons
        iconFilled: {
          color: mainColor, // Replace with your desired filled color
        },
        // Target the hover state icon color
        iconHover: {
          color: mainColor, // Replace with your desired hover color
        },
        // Optional: Target the empty/unfilled star icons
        iconEmpty: {
          color: mainColor, // Replace with your desired empty outline color
        },
      },
    },
    }
})
export default theme;